export const DELETE_MESSENGER_LINK_URL = 'v2/account/messenger-link/max/'

export type Resp = {
  messenger: string
  is_linked: boolean
  was_linked: boolean
}
